// extracted by mini-css-extract-plugin
export default {"thead":"DesignTable_thead__2Mo1d","tbody":"DesignTable_tbody__QdIod","valid":"DesignTable_valid__fAl3L","inValid":"DesignTable_inValid__w0oS6","info":"DesignTable_info__MZiai"};